import React from 'react';
import {
    Box,
    Skeleton,
    FormControlLabel,
    Radio,
    Select,
    MenuItem,
    Button
} from '@mui/material';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import WifiTetheringOutlinedIcon from '@mui/icons-material/WifiTetheringOutlined';
import './../../custom.css';

function SkeletonTriageAlerts({ loading = true , rowCount = 5}) {  // default true here
    return (
        <Box className="triage-container">
            {loading ? (
                <>
                    {/* Summary Section */}
                    <Box className="summary-section">
                        {/* Equipment Health */}
                        <Box className="summary-block">
                            <Skeleton variant="text" width={240} height={40} />
                            <Skeleton variant="text" width={240} height={40} />
                        </Box>

                        {/* Device Health */}
                        <Box className="summary-block">
                            <Skeleton variant="text" width={240} height={40} />
                            <Skeleton variant="text" width={240} height={40} />
                        </Box>
                    </Box>

                    {/* Tabs Section */}
                    <Box className="tabs-section">
                        {/* Tab 1 */}
                        <Box className="tab tab-one">
                            <NotificationsNoneOutlinedIcon className="tab-icon" />
                            <Skeleton variant="text" width={110} height={22} />
                            <Skeleton variant="rectangular" width={70} height={22} className="tab-skeleton" />
                            <Skeleton variant="rectangular" width={90} height={22} className="tab-skeleton" />
                        </Box>

                        {/* Tab 2 */}
                        <Box className="tab tab-two">
                            <WifiTetheringOutlinedIcon className="tab-icon" />
                            <Skeleton variant="text" width={110} height={22} />
                            <Skeleton variant="rectangular" width={70} height={26} className="tab-skeleton" />
                            <Skeleton variant="rectangular" width={90} height={26} className="tab-skeleton" />
                        </Box>
                    </Box>

                    {/* Filters Section */}
                    <Box className="filters-section">
                        <FormControlLabel
                            control={<Radio size="small" />}
                            label={<Skeleton width={50} height={18} />}
                        />
                        <FormControlLabel
                            control={<Radio size="small" />}
                            label={<Skeleton width={70} height={18} />}
                        />
                        <FormControlLabel
                            control={<Radio size="small" />}
                            label={<Skeleton width={60} height={18} />}
                        />

                        {[110, 160, 120, 160].map((width, index) => (
                            <Select
                                key={index}
                                variant="outlined"
                                className="filter-select"
                                disabled
                                size="small"
                            >
                                <MenuItem>
                                    <Skeleton width={width - 40} height={18} />
                                </MenuItem>
                            </Select>
                        ))}

                        <Button variant="contained" disabled className="filter-button">
                            <Skeleton width={70} height={28} />
                        </Button>
                        <Button variant="outlined" disabled className="filter-button">
                            <Skeleton width={90} height={28} />
                        </Button>
                    </Box>
                </>
            ) : null}

            {/* Table Header */}
            <Box className="table-header">
                {['SEVERITY', 'CUSTOMER', 'COUNT', 'ALERT', 'PROBLEM', 'START', 'END'].map((text, i) => (
                    <Box
                        key={i}
                        className={`table-header-cell ${i === 4 ? 'wide' : ''}`}
                    >
                        {loading ? (
                            <Skeleton variant="text" width={text.length * 11} height={40} />
                        ) : (
                            <strong>{text}</strong>
                        )}
                    </Box>
                ))}
            </Box>

            {/* Table Rows */}
            {[...Array(rowCount)].map((_, idx) => (
                <Box key={idx} className="table-row">
                    {
                        <>
                            <Skeleton variant="rectangular" width={15} height={15} className="row-checkbox" />
                            <Skeleton variant="circular" width={15} height={15} />
                            <Skeleton variant="circular" width={20} height={20} />
                            <Skeleton variant="text" width={100} height={30} />
                            <Skeleton variant="text" width={18} height={18} />
                            <Skeleton variant="text" width={100} height={40} />
                            <Skeleton variant="text" width={260} height={40} className="row-problem" />
                            <Skeleton variant="text" width={100} height={40} />
                            <Skeleton variant="text" width={100} height={30} />
                            <Skeleton variant="circular" width={20} height={20} />
                        </>
                     }
                </Box>
            ))}
        </Box>
    );
};

export default SkeletonTriageAlerts;
